"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureAuth = void 0;
var core_1 = require("@aws-amplify/core");
var defaultSignInFailureHandler = function (errorMessage) {
    var params = new URLSearchParams();
    params.append("signInError", errorMessage);
    window.location.assign("/signIn?" + params);
};
function configureAuth(config, opts) {
    core_1.Amplify.configure(config);
    var _a = (opts !== null && opts !== void 0 ? opts : {}).signInFailureHandler, signInFailureHandler = _a === void 0 ? defaultSignInFailureHandler : _a;
    // As soon as Amplify is configured, it controls OAuth-specific query parameters like `code`, `state`, and
    // `error_description`. Prior versions did not remove the `error_description`, so we could handle sign-in failures
    // ourselves. However, newer versions clear the parameter before we can deal with it in application code.
    // Therefore, we have to set up an Auth channel listener to redirect to our sign-in page with the error message if
    // OAuth login fails.
    // https://docs.amplify.aws/lib/utilities/hub/q/platform/js/#listening-for-messages
    core_1.Hub.listen("auth", function (_a) {
        var _b = _a.payload, event = _b.event, data = _b.data;
        if (event === "signIn_failure") {
            var message = data.message.replaceAll("+", " ");
            signInFailureHandler(message);
        }
    });
}
exports.configureAuth = configureAuth;
//# sourceMappingURL=config.js.map